<div [ngClass]="{'pointer': isPointer}" class="icon-container">
    <img class="icon" [src]="svgIcon">
</div>